import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { store } from '../store';
import { EndPoints } from '../../axios/endPoints';
import { axiosInstance } from '../../axios/axiosHandler';

export interface Auth {
  loading: boolean;
  user: {
    email: string | null;
    role: string | null;
  };
  token: string | null;
}

interface AuthProps {
  success: boolean;
  expiration: string | null;
  user: string | null;
  userRoles: [string] | null;
  token: string | null;
}

export interface LogInData {
  email: string;
  password: string;
  remember: boolean;
}

export function authHeader() {
  const token = authToken();
  const isLoggedIn = !!token;
  if (isLoggedIn) {
    return {
      headers: { Authorization: `Bearer ${token}` },
    };
  } else {
    return {};
  }
}

function authToken() {
  return store.getState().auth?.token;
}

export const performLogIn = createAsyncThunk(
  'LogIn',
  async (payload: LogInData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(EndPoints.LOG_IN, {
        username: payload.email,
        password: payload.password,
        remember: payload.remember,
      });
      return await response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ?? 'Something went wrong.'
      );
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState:
    localStorage.getItem('auth') !== null
      ? JSON.parse(localStorage.getItem('auth') as string)
      : {
          loading: false,
          user: {
            email: null as string | null,
            role: null as number | null,
          },
          token: null as string | null,
        },
  reducers: {
    handleLogOut: (state) => {
      state = {
        loading: false,
        user: {
          email: null,
          role: null,
        },
        token: null,
      };

      localStorage.setItem('auth', JSON.stringify(state));
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(performLogIn.pending, (state, action) => {
      state.loading = true;
    });

    builder.addCase(performLogIn.rejected, (state, action) => {
      state = {
        loading: false,
        user: {
          email: null,
          role: null
        },
        token: null,
      };

      return state;
    });

    builder.addCase(performLogIn.fulfilled, (state, action) => {
      const { success, user, userRoles, token } =
        action.payload as AuthProps;

      if (success) {
        state = {
          loading: false,
          user: {
            email: user ?? null,
            role: userRoles?.[0] ?? null,
          },
          token: token ?? null,
        };

        localStorage.setItem('auth', JSON.stringify(state));

        return state;
      } else
        state = {
          loading: false,
          user: {
            email: null,
            role: null
          },
          token: null,
        };

      return state;
    });
  },
});

export const { handleLogOut } = authSlice.actions;

export const authSelector = (state: RootState) => state.auth;
